import {
  View,
  Image,
  Text,
  StyleSheet,
  TouchableOpacity,
  Platform,
} from "react-native";

import Centered from "../../../../shared/Centered";
import { BGHorDivider, JackpotCoin, JackpotHistory } from "../../../../assets";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { FormatWithThousandSeparator } from "../../../../utils/helpers/numberFormat";
import { miniGamesRewardsRequest } from "../../../../store/jackpot/miniGamesRewardsActions";
import { selectMiniGamesGoldAmount } from "../../../../store/jackpot/miniGamesRewardsReducer";
import { useEffect, useState } from "react";
import JackpotHistoryModal from "../JackpotHistoryModal";
import { useDevice } from "../../../../utils/hooks/useDevice";
import { isDesktop } from "@rnv/renative";

interface IProps {
  isSmall: boolean;
}

function BGJackpotLabel({ isSmall }: IProps) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const goldAmount = useSelector(selectMiniGamesGoldAmount);
  const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);
  const { width } = useDevice();

  useEffect(() => {
    dispatch(miniGamesRewardsRequest());
  }, [dispatch]);

  const formattedGoldAmount = FormatWithThousandSeparator(
    Math.floor(goldAmount ?? 0),
    { hideFractIfInteger: true },
  );

  const isWeb = Platform.OS === "web";
  const isNative = !isWeb;
  const containerWidth = isSmall ? width * 0.7 : 800;

  // On native, use parent-relative width so we fit inside the modal (90% of screen)
  const centeredWidth = isSmall && isNative ? "100%" : isSmall ? "100%" : 800;

  return (
    <>
      <Centered
        style={{
          width: centeredWidth,
          alignItems: "center",
          justifyContent: "center",
          paddingHorizontal: 10,
          marginBottom: isSmall ? 0 : 10,
          marginTop: isSmall ? -20 : -2,
        }}
      >
        <View style={[styles.row, { maxWidth: isSmall ? width * 0.6 : 800 }]}>
          <TouchableOpacity
            activeOpacity={1}
            onPress={() => setIsHistoryModalOpen(true)}
            style={{
              alignSelf: "center",
              width: isSmall ? 100 : 80,
              marginTop: isSmall ? 2 : 4,
            }}
          >
            <View
              style={{
                width: isSmall ? 120 : 100,
                height: isSmall ? 80 : 60,
              }}
            >
              <Image
                source={JackpotHistory}
                resizeMode="contain"
                style={{
                  width: isSmall ? 80 : 60,
                  height: isSmall ? 80 : 60,
                  aspectRatio: 120 / 120,
                }}
              />
            </View>
          </TouchableOpacity>
          <View>
            <Text
              style={[
                styles.commmon,
                {
                  fontSize: isSmall ? 16 : 22,
                  marginRight: -40,
                  marginLeft: -30,
                },
              ]}
            >
              {t("T_Jackpot")}
            </Text>
          </View>
          <View>
            <Image
              source={JackpotCoin}
              resizeMode="contain"
              style={{
                width: isSmall ? 180 : 200,
                // aspectRatio: 180 / 140,
                minHeight: 70,

                marginBottom: 10,
              }}
            />
          </View>
          <View>
            <Text
              style={[
                styles.commmon,
                {
                  fontSize: isSmall ? 16 : 22,
                  marginLeft: -40,
                },
              ]}
            >
              {formattedGoldAmount}
            </Text>
          </View>
        </View>
      </Centered>
      <View
        style={{
          width: containerWidth,
          alignSelf: "center",
          justifyContent: "center",
          alignItems: "center",
          marginTop: isSmall ? -20 : -10,
          marginBottom: isSmall ? 12 : 20,
        }}
      >
        {isSmall && (
          <Image
            style={{ height: 10, aspectRatio: 300 / 10 }}
            source={BGHorDivider}
          />
        )}
      </View>
      {isHistoryModalOpen && (
        <JackpotHistoryModal onClose={() => setIsHistoryModalOpen(false)} />
      )}
    </>
  );
}

const styles = StyleSheet.create({
  commmon: {
    // position: "absolute",
    color: "#fbe28f",
    fontWeight: "bold",
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 2,
    height: 80,
  },
});

export default BGJackpotLabel;
